module.exports = function() {
  return new Worker(__webpack_public_path__ + "7e10e1fbd7a4e4a5ac72.worker.js");
};